import { styles } from "../../ReportCard.style";

export interface ReportCardRowProps {
  title: string;
  value: string;
  isPurchasedField?: boolean;
}

const ReportCardRow = (props: ReportCardRowProps) => {
  const { title, value, isPurchasedField } = props;

  return (
    <div className={isPurchasedField ? styles.purchasedField() : undefined}>
      <div className={styles.title()}>{title}</div>
      <div className={styles.contentValue()}>{value}</div>
    </div>
  );
};

export default ReportCardRow;
